import React, { useEffect } from "react";
import { Card, Button, Badge } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { FaBuilding, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const InfoWindow = ({ close, data, lat, lng, setCenter, darkMode }) => {
  const history = useHistory();

  const handleClick = (data) => {
    if (data._id) {
      history.push(`/units/${data._id}`);
    }
  };

  useEffect(() => {
    setCenter({
      lat: lat,
      lng: lng
    });
  }, [setCenter, lat, lng]);

  // Cores baseadas no tema
  const bgColor = darkMode 
    ? "rgba(30, 30, 30, 0.85)" 
    : "rgba(255, 255, 255, 0.85)";
  
  const textColor = darkMode ? "#e9ecef" : "#212529";
  const borderColor = darkMode ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.1)";

  return (
    <Card
      border={darkMode ? "info" : "success"}
      className="info-window map-info-window"
      style={{
        position: "relative",
        width: 375,
        transform: "translate(-50%, -100%)",
        backgroundColor: bgColor,
        color: textColor,
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
        borderRadius: "12px",
        border: `1px solid ${borderColor}`,
        zIndex: 999,
        backdropFilter: "blur(6px)",
      }}
    >
      <Card.Header 
        style={{ 
          display: "flex", 
          justifyContent: "space-between", 
          alignItems: "center",
          backgroundColor: darkMode ? "rgba(0,0,0,0.2)" : "rgba(255,255,255,0.2)",
          borderBottomColor: borderColor
        }}
      >
        <h6 className="mt-1 mb-1">
          <FaBuilding className="me-2" /> {data.name || "--"}
        </h6>
        <Button
          variant={darkMode ? "outline-light" : "outline-secondary"}
          size="sm"
          onClick={close}
          style={{ borderRadius: "50%", padding: "2px 6px", fontSize: "12px" }}
        >
          ✕
        </Button>
      </Card.Header>
      <Card.Body>
        {data.typeCompany && (
          <Badge 
            bg={darkMode ? "info" : "success"} 
            className="mb-2">
            Cooperativa
          </Badge>
        )}
        
        <p style={{ margin: "4px 0" }}>
          <FaPhone className="me-2" />
          {data.fone || "--"}
        </p>
        
        <p style={{ margin: "4px 0" }}>
          <FaEnvelope className="me-2" />
          {data.email || "--"}
        </p>
        
        <p style={{ margin: "4px 0" }}>
          <FaMapMarkerAlt className="me-2" />
          {data.address || "--"}
        </p>
        
        <p style={{ margin: "4px 0" }}>
          <strong>Equipamentos:</strong> {data.equipments?.length || 0}
        </p>
      </Card.Body>
      <Card.Footer style={{ backgroundColor: darkMode ? "rgba(0,0,0,0.2)" : "rgba(255,255,255,0.2)" }}>
        <Button
          size="sm"
          variant={darkMode ? "outline-light" : "secondary"}
          onClick={() => {
            handleClick(data);
          }}
        >
          Ver Detalhes
        </Button>
      </Card.Footer>
    </Card>
  );
};

export default InfoWindow;
